import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'EditDocumentIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M7 2L18 2L18 20L3 20L3 7Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 2L7 7L3 7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M10.5 18L10 15.5L18 7.5L20.5 10L12.5 18Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="none"
      />
      <line x1="10" y1="15.5" x2="12.5" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
});
